export enum CATEGORY {
  LIST = '/categories/list',
  ADD = '/categories/add',
  EDIT = '/categories/edit/:id',
  ARTICLE = '/categories/:id/articles',
}
